import { BookingSummaryItem } from './booking-summary-item.interface';
import { ICommunicationPreferences } from './communication-preferences.interface';
import { ICustomerDetails } from './customer-details.interface';
export interface BookingSummary {
  items: BookingSummaryItem[];
  billingAddress?: ICustomerDetails;
  accountHolder?: ICustomerDetails;
  communicationPreferences?: ICommunicationPreferences;
}
